// Copy to frontend src/utils/pricingPlanUtils.js and beside backend pricingPlanRoutes.js.
export const LEGACY_CYCLE_MONTHS = Object.freeze({
  month: 1, monthly: 1, quarter: 3, halfYear: 6, year: 12,
});

export function durationLabel(months) {
  return `${months} Month${Number(months) === 1 ? "" : "s"}`;
}

export function normalizeBillingCycles(cycles = {}, legacyFeatures = []) {
  return Object.fromEntries(Object.entries(cycles || {}).map(([key, cycle]) => {
    const months = cycle?.months ?? LEGACY_CYCLE_MONTHS[key] ?? "";
    return [key, {
      ...cycle,
      months: months === "" ? "" : Number(months),
      label: cycle?.label || (months ? durationLabel(months) : key),
      price: cycle?.price ?? "",
      contactLimit: cycle?.contactLimit === null ? null : cycle?.contactLimit ?? 0,
      chatbotNodeLimit: cycle?.chatbotNodeLimit ?? 0,
      features: Array.isArray(cycle?.features)
        ? [...cycle.features]
        : [...legacyFeatures],
      newFeature: "",
    }];
  }));
}

export function getBillingOptions(plan) {
  return Object.entries(
    normalizeBillingCycles(plan?.billingCycles, plan?.features || [])
  )
    .map(([key, cycle]) => ({ ...cycle, key }))
    .filter((cycle) => Number.isSafeInteger(cycle.months) && cycle.months > 0)
    .sort((a, b) => a.months - b.months);
}

export function moneyBreakdown(price) {
  const basePaise = Math.round(Number(price) * 100);
  const gstPaise = Math.round(basePaise * 0.18);
  return {
    baseAmount: basePaise / 100,
    gstAmount: gstPaise / 100,
    totalAmount: (basePaise + gstPaise) / 100,
  };
}
